(() => {
  let updating = false;

  document.addEventListener('change', async event => {
    const checkbox = event.target.closest('[data-installation-checkbox]');
    if (!checkbox) return;

    const option = checkbox.closest('[data-installation-option]');
    const item = checkbox.closest('.cart__item[data-key]');
    if (!option || !item) return;

    if (updating) {
      checkbox.checked = !checkbox.checked;
      return;
    }

    updating = true;
    const selected = checkbox.checked;
    const status = option.querySelector('[data-installation-status]');
    const checkoutButtons = [...document.querySelectorAll('.cart__checkout')];
    const previousDisabled = checkoutButtons.map(button => button.disabled);
    document.querySelectorAll('[data-installation-checkbox]').forEach(input => { input.disabled = true; });
    checkoutButtons.forEach(button => { button.disabled = true; });
    status.classList.remove('is-error');
    status.textContent = option.dataset.savingText;

    try {
      const cartResponse = await fetch(theme.routes.cart, { credentials: 'same-origin' });
      if (!cartResponse.ok) throw new Error('Could not read cart');
      const cart = await cartResponse.json();
      const index = cart.items.findIndex(line => line.key === item.dataset.key);
      if (index < 0) throw new Error('Cart item changed');

      const properties = { ...cart.items[index].properties };
      properties['Installation requested'] = selected ? 'Yes' : 'No';
      const changeResponse = await fetch(theme.routes.cartChange, {
        method: 'POST',
        credentials: 'same-origin',
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/json',
          'X-Requested-With': 'XMLHttpRequest'
        },
        body: JSON.stringify({ line: index + 1, properties })
      });
      if (!changeResponse.ok) throw new Error('Could not update cart');
      const updatedCart = await changeResponse.json();
      if (updatedCart.status) throw new Error('Could not update cart');

      document.dispatchEvent(new CustomEvent('cart:build'));
      document.dispatchEvent(new CustomEvent('cart:updated', { detail: { cart: updatedCart } }));
    } catch (error) {
      checkbox.checked = !selected;
      status.classList.add('is-error');
      status.textContent = option.dataset.errorText;
    } finally {
      updating = false;
      document.querySelectorAll('[data-installation-checkbox]').forEach(input => { input.disabled = false; });
      checkoutButtons.forEach((button, index) => { button.disabled = previousDisabled[index]; });
    }
  });
})();
